import i18n from './i18n-setup';

// BCP 47 tag for Intl / toLocale* calls, following the active UI language.
export const intlLocale = (): string => (i18n.language === 'vi' ? 'vi-VN' : 'en-US');

export const formatDate = (d: Date | string | number, options?: Intl.DateTimeFormatOptions): string =>
  new Date(d).toLocaleDateString(intlLocale(), options);

export const formatDateTime = (d: Date | string | number, options?: Intl.DateTimeFormatOptions): string =>
  new Date(d).toLocaleString(intlLocale(), options);

export const formatNumber = (n: number, options?: Intl.NumberFormatOptions): string =>
  n.toLocaleString(intlLocale(), options);
